import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { SMS_ADD, LOGOUT } from 'ConstComponents';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CustomeAlert } from 'Components/Alert/Alert';
import { useHistory } from 'react-router';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MESSAGE_CLOSE_AFTER } from 'Components/Helper/Messages';
import Box from '@material-ui/core/Box';
export const SmsAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [loading, setLoading] = useState(false);

    var ModelObj = {
        SmsString: '',
        BalanceCheckUrl: ''
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var requestObj = JSON.stringify(values);
        setIsError(false);
        setLoading(true);
        var response = await SMS_ADD(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setIsError(true);
        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            setLoading(false);
            return;
        }

        resetForm(ModelObj);

        setTimeout(() => {
            history.push('/SMS/Index');
        }, MESSAGE_CLOSE_AFTER);
    };

    const SmsScheama = Yup.object({
        SmsString: Yup.string()
            .trim()
            .required('Please enter valid sms string.'),

        BalanceCheckUrl: Yup.string()
            .trim()
            .required('Please enter valid balance url.')
    });
    const resethandle = resetForm => {};
    return (
        <>
            {isError ? (
                <CustomeAlert
                    isOpen={isError}
                    message={responseMessage}
                    severity={severity}
                    onCloseCallback={alertState => {
                        setIsError(alertState);
                    }}
                />
            ) : null}
            <Formik
                enableReinitialize={true}
                initialValues={ModelObj}
                validationSchema={SmsScheama}
                onSubmit={submithandle}
                onReset={resethandle}
                render={formProps => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                {' '}
                                SMS Details{' '}
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={4} item>
                                            <MaterialTextField
                                                label="SmsString"
                                                name="SmsString"
                                                type="text"
                                                title="SMS URL"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4} item>
                                            <MaterialTextField
                                                label="BalanceCheckUrl"
                                                name="BalanceCheckUrl"
                                                type="text"
                                                title="Balance Check URL"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Register"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loading}
                                        >
                                            Add
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>

                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </>
    );
};
